import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export default function TermsOfService() {
  const { t, i18n } = useTranslation(['pages.terms']);

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 relative">
      {/* Language Selector */}
      <div className="absolute top-4 right-4 z-10">
        <Select value={i18n.language} onValueChange={handleLanguageChange}>
          <SelectTrigger className="w-32 bg-white/90 backdrop-blur-sm">
            <Globe className="w-4 h-4 mr-2" />
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="en">EN</SelectItem>
            <SelectItem value="de">DE</SelectItem>
            <SelectItem value="tr">TR</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-bold">{t('pages.terms:title')}</CardTitle>
            <p className="text-sm text-gray-600 mt-2">{t('pages.terms:lastUpdated')}</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.acceptance.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.acceptance.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.serviceDescription.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.serviceDescription.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.userAccounts.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-3">{t('pages.terms:sections.userAccounts.intro')}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t('pages.terms:sections.userAccounts.items.accuracy')}</li>
                <li>{t('pages.terms:sections.userAccounts.items.security')}</li>
                <li>{t('pages.terms:sections.userAccounts.items.responsibility')}</li>
                <li>{t('pages.terms:sections.userAccounts.items.notification')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.acceptableUse.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-3">{t('pages.terms:sections.acceptableUse.intro')}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t('pages.terms:sections.acceptableUse.items.illegal')}</li>
                <li>{t('pages.terms:sections.acceptableUse.items.harmful')}</li>
                <li>{t('pages.terms:sections.acceptableUse.items.unauthorized')}</li>
                <li>{t('pages.terms:sections.acceptableUse.items.interference')}</li>
                <li>{t('pages.terms:sections.acceptableUse.items.spam')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.intellectualProperty.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.intellectualProperty.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.subscription.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-3">{t('pages.terms:sections.subscription.intro')}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t('pages.terms:sections.subscription.items.billing')}</li>
                <li>{t('pages.terms:sections.subscription.items.renewal')}</li>
                <li>{t('pages.terms:sections.subscription.items.cancellation')}</li>
                <li>{t('pages.terms:sections.subscription.items.refunds')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.liability.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.liability.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.termination.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.termination.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.changes.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.changes.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.governingLaw.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.governingLaw.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.terms:sections.contact.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.terms:sections.contact.content')}</p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
